import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.dataProcessingProgress;

const DataProcessingProgressData = createSelector([selector], (state) => state);

export default {
  DataProcessingProgressData
};
